/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * An error message seen in a health window, with how often it occurred.
 * @export
 * @interface ErrorMessageCount
 */
export interface ErrorMessageCount {
    /**
     * 
     * @type {Date}
     * @memberof ErrorMessageCount
     */
    lastSeenAt: Date;
    /**
     * 
     * @type {number}
     * @memberof ErrorMessageCount
     */
    count: number;
    /**
     * The stored error text. Null when the failure recorded no message.
     * @type {string}
     * @memberof ErrorMessageCount
     */
    message?: string | null;
}

/**
 * Check if a given object implements the ErrorMessageCount interface.
 */
export function instanceOfErrorMessageCount(value: object): value is ErrorMessageCount {
    if (!('lastSeenAt' in value) || value['lastSeenAt'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ErrorMessageCountFromJSON(json: any): ErrorMessageCount {
    return ErrorMessageCountFromJSONTyped(json, false);
}

export function ErrorMessageCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorMessageCount {
    if (json == null) {
        return json;
    }
    return {
        
        'lastSeenAt': (new Date(json['lastSeenAt'])),
        'count': json['count'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function ErrorMessageCountToJSON(value?: ErrorMessageCount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lastSeenAt': ((value['lastSeenAt']).toISOString()),
        'count': value['count'],
        'message': value['message'],
    };
}

